var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30139 10.2764V18.2764H20.6812V10.2764L12.4913 13.2764L4.30139 10.2764ZM4.30139 6.27637V8.27637L12.4913 11.2764L20.6812 8.27637V6.27637H4.30139ZM4.30139 4.27637H20.6812C21.2243 4.27637 21.7451 4.48708 22.129 4.86215C22.513 5.23723 22.7287 5.74593 22.7287 6.27637V18.2764C22.7287 18.8068 22.513 19.3155 22.129 19.6906C21.7451 20.0657 21.2243 20.2764 20.6812 20.2764H4.30139C3.75836 20.2764 3.23758 20.0657 2.8536 19.6906C2.46962 19.3155 2.25391 18.8068 2.25391 18.2764V6.27637C2.25391 5.74593 2.46962 5.23723 2.8536 4.86215C3.23758 4.48708 3.75836 4.27637 4.30139 4.27637Z",
    fill: "#053f66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3bfd6f559e7b08ea78691d551d54d90a.svg";
export { ForwardRef as ReactComponent };